import React from "react";
// Associated Meter Events & Logs

// Mui
import Typography from "@mui/material/Typography";
import Card from "@mui/material/Card";
import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import Grid from "@mui/material/Grid2";
import useMediaQuery from "@mui/material/useMediaQuery";

// Custom

// Theme
import theme from "../../theme";

// Svg
import Collection from "../../assets/svg/correction";

// Images
import MeterMd from "../../assets/images/electric-meter-line-icon-vector md.png";

const HeaderAssociatedMeterLogs: React.FC = () => {
  const matches = useMediaQuery(theme.breakpoints.down("lg"));

  const getAssociatedMeterLogsCard1 = (color1: string, color2: string) => {
    return (
      <Grid size={4}>
        <Card
          className="associated_meter_logs_card"
          sx={{
            position: "relative",
            borderBottom: "none",
            "::before": {
              content: '""',
              position: "absolute",
              bottom: "0",
              left: "0",
              width: "100%",
              height: "6px",
              background: `linear-gradient(0deg, ${color1} 1.7%, ${color2} 11.34%)`,
              zIndex: 1,
            },
            "::after": {
              content: '""',
              position: "absolute",
              bottom: "0",
              left: "0",
              width: "100%",
              height: "6px",
              background: `repeating-linear-gradient(45deg, transparent, transparent 2px, ${color1} 2px, ${color2} 4px)`,
              zIndex: 2,
            },
          }}>
          <Box
            display={"flex"}
            flexDirection={"column"}
            justifyContent={"center"}>
            <img src={MeterMd} alt="Meter" />
          </Box>
          <Box
            width={"100%"}
            display={"flex"}
            flexDirection={"column"}
            gap={"18px"}>
            <Stack
              direction={"row"}
              justifyContent={"space-between"}
              alignItems={"center"}>
              <Stack>
                <Typography className="associated_meter_logs_card_title">
                  Total Meters: 50,000+
                </Typography>
                <Typography variant="body2" fontSize={"10px"} color="#5F6368">
                  Current count
                </Typography>
              </Stack>
            </Stack>

            <Stack
              direction={"row"}
              justifyContent={"space-between"}
              alignItems={"center"}>
              <Stack>
                <Typography className="">
                  Connected Meters: <span color="#3edb3e">49,000+</span>
                </Typography>
                <Typography variant="body2" fontSize={"10px"} color="#5F6368">
                  Current count
                </Typography>
              </Stack>
            </Stack>

            <Stack
              direction={"row"}
              justifyContent={"space-between"}
              alignItems={"center"}>
              <Stack>
                <Typography className="">
                  Disconnected Meters: <span color="#db3e3e">1,000+</span>
                </Typography>
                <Typography variant="body2" fontSize={"10px"} color="#5F6368">
                  Current count
                </Typography>
              </Stack>
            </Stack>

            <Stack
              direction={"row"}
              justifyContent={"space-between"}
              alignItems={"center"}>
              <Stack>
                <Typography variant="caption" fontWeight={600}>
                  19 Sep’24
                  <Typography
                    variant="caption"
                    fontWeight={400}
                    color="#5F6368">
                    {" "}
                    05:55:24 pm.
                  </Typography>{" "}
                </Typography>
                <Typography
                  variant="body2"
                  color="#5F6368"
                  fontSize={"10px"}
                  lineHeight={"12px"}>
                  Anomaly Date
                </Typography>
              </Stack>
            </Stack>
          </Box>
        </Card>
      </Grid>
    );
  };

  const getAssociatedMeterLogsCard2 = (color1: string, color2: string) => {
    return (
      <Grid size={4}>
        <Card
          className="associated_meter_logs_card"
          sx={{
            position: "relative",
            borderBottom: "none",
            "::before": {
              content: '""',
              position: "absolute",
              bottom: "0",
              left: "0",
              width: "100%",
              height: "6px",
              background: `linear-gradient(0deg, ${color1} 1.7%, ${color2} 11.34%)`,
              zIndex: 1,
            },
            "::after": {
              content: '""',
              position: "absolute",
              bottom: "0",
              left: "0",
              width: "100%",
              height: "6px",
              background: `repeating-linear-gradient(45deg, transparent, transparent 2px, ${color1} 2px, ${color2} 4px)`,
              zIndex: 2,
            },
          }}>
          <Box
            display={"flex"}
            flexDirection={"column"}
            justifyContent={"center"}>
            <img src={MeterMd} alt="Meter" />
          </Box>
          <Box
            width={"100%"}
            display={"flex"}
            flexDirection={"column"}
            gap={"18px"}>
            <Stack
              direction={"row"}
              justifyContent={"space-between"}
              alignItems={"center"}>
              <Stack>
                <Typography className="associated_meter_logs_card_title">
                  Total Active Meters: 49,000+
                </Typography>
                <Typography variant="body2" fontSize={"10px"} color="#5F6368">
                  Current count
                </Typography>
              </Stack>
            </Stack>

            <Stack
              direction={"row"}
              justifyContent={"space-between"}
              alignItems={"center"}>
              <Stack>
                <Typography className="">
                  Investigated Meters: <span color="#3edb3e">45,000+</span>
                </Typography>
                <Typography variant="body2" fontSize={"10px"} color="#5F6368">
                  Current count
                </Typography>
              </Stack>
            </Stack>

            <Stack
              direction={"row"}
              justifyContent={"space-between"}
              alignItems={"center"}>
              <Stack>
                <Typography className="">
                  Invetigation Needed: <span color="#db3e3e">4,000+</span>
                </Typography>
                <Typography variant="body2" fontSize={"10px"} color="#5F6368">
                  Current count
                </Typography>
              </Stack>
            </Stack>

            <Stack
              direction={"row"}
              justifyContent={"space-between"}
              alignItems={"center"}>
              <Stack direction={"row"} gap={"5px"}>
                <Collection fill={"#1280E7"} />
                <Box>
                  <Typography variant="body2" fontWeight={600}>
                    Investigate usage
                  </Typography>
                  <Typography variant="body2" fontSize={"10px"} color="#5F6368">
                    Suggested Action
                  </Typography>
                </Box>
              </Stack>
            </Stack>
          </Box>
        </Card>
      </Grid>
    );
  };

  const getAssociatedMeterLogsCard3 = (color1: string, color2: string) => {
    return (
      <Grid size={4}>
        <Card
          className="associated_meter_logs_card"
          sx={{
            position: "relative",
            borderBottom: "none",
            "::before": {
              content: '""',
              position: "absolute",
              bottom: "0",
              left: "0",
              width: "100%",
              height: "6px",
              background: `linear-gradient(0deg, ${color1} 1.7%, ${color2} 11.34%)`,
              zIndex: 1,
            },
            "::after": {
              content: '""',
              position: "absolute",
              bottom: "0",
              left: "0",
              width: "100%",
              height: "6px",
              background: `repeating-linear-gradient(45deg, transparent, transparent 2px, ${color1} 2px, ${color2} 4px)`,
              zIndex: 2,
            },
          }}>
          <Box
            display={"flex"}
            flexDirection={"column"}
            justifyContent={"center"}>
            <img src={MeterMd} alt="Meter" />
          </Box>
          <Box
            width={"100%"}
            display={"flex"}
            flexDirection={"column"}
            gap={"18px"}>
            <Stack
              direction={"row"}
              justifyContent={"space-between"}
              alignItems={"center"}>
              <Stack>
                <Typography className="associated_meter_logs_card_title">
                  Avg. Usage/month: 4523+ kW
                </Typography>
                <Typography variant="body2" fontSize={"10px"} color="#5F6368">
                  Current count
                </Typography>
              </Stack>
            </Stack>

            <Stack
              direction={"row"}
              justifyContent={"space-between"}
              alignItems={"center"}>
              <Stack>
                <Typography className="">
                  Avg. Usage/day: <span color="#3edb3e">150.77+ kW</span>
                </Typography>
                <Typography variant="body2" fontSize={"10px"} color="#5F6368">
                  Current count
                </Typography>
              </Stack>
            </Stack>

            <Stack
              direction={"row"}
              justifyContent={"space-between"}
              alignItems={"center"}>
              <Stack>
                <Typography className="">
                  Avg. Usage/hour: <span color="#db3e3e">6.25+ kW</span>
                </Typography>
                <Typography variant="body2" fontSize={"10px"} color="#5F6368">
                  Current count
                </Typography>
              </Stack>
            </Stack>

            <Stack
              direction={"row"}
              justifyContent={"space-between"}
              alignItems={"center"}>
              <Stack>
                <Typography variant="body2" fontWeight={600}>
                  20 May’25
                </Typography>
                <Typography
                  variant="body2"
                  color="#5F6368"
                  fontSize={"10px"}
                  lineHeight={"12px"}>
                  Last Calculated Date
                </Typography>
              </Stack>
            </Stack>
          </Box>
        </Card>
      </Grid>
    );
  };

  return (
    <Grid
      container
      columnSpacing={1}
      // className="associated_meter_logs"
      // sx={{ p: "13px 18px 19px 15px" }}
    >
      {getAssociatedMeterLogsCard1("#FFC400", "#FF6F00")}
      {getAssociatedMeterLogsCard2("#94DB4B", "#4D8C0C")}
      {getAssociatedMeterLogsCard3("#ff996c", "#ff0000")}
    </Grid>
  );
};

export default HeaderAssociatedMeterLogs;
